/** A question counts as answered once it has a non-empty value. */
export const isAnswered = (value: string | string[] | undefined): boolean => {
    if (value == null) return false;
    if (Array.isArray(value)) return value.length > 0;
    return value !== "";
};
